import React, { createRef, useEffect, useState } from "react";
import "../Member/member.css";
import add from "../../images/icons/add.png";
import close from "../../images/icons/close.png";
import CustomButton from "../../components/CustomButton/custombutton";
import edit from "../../images/icons/edit.png";
import view from "../../images/icons/view.png";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../api/apiUtil";
import { Box } from "@material-ui/core";
import Table from "../../components/Table/Table";
import api from "../../api/api";
import getToken, { redirectToLogin } from "../getToken";
import authStore from "../../store/authStore";
import CustomInput from "../../components/CustomInput/CustomInput";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import calenderIcon from "../../images/icons/calendar.png";
import { message } from "antd";

const Member = () => {
  const refMemberTable = createRef();
  // const [selectedOption, setSelectedOption] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [keyword, setKeyword] = useState("");

  const [showAddMember, setShowAddMember] = useState(false);
  const [detailMember, setDetailMember] = useState({
    name: "",
    marker_name: "",
    address: "",
    phone_number: "",
  });

  const brandId = authStore((state) => state.auth?.brandId);
  const clickEditMember = (rowData) => {
    setShowAddMember(false);
    setIsView(false);
    setIsEdit(true);
    setDetailMember({
      name: rowData.name,
      marker_name: rowData.markerName,
      address: rowData.address,
      phone_number: rowData.phoneNo,
      memberId: rowData.id,
      brandId: rowData.brandId,
    });

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const clickViewMember = (rowData) => {
    setShowAddMember(false);
    setIsEdit(false);
    setIsView(true);
    setDetailMember({
      name: rowData.name,
      marker_name: rowData.markerName,
      address: rowData.address,
      phone_number: rowData.phoneNo,
      memberId: rowData.id,
      brandId: rowData.brandId,
    });
    retrieveReportList();
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const clickAddMember = () => {
    setShowAddMember(true);
    setIsEdit(false);
    setIsView(false);
    setDetailMember({});
  };

  const clickBtnCloseForm = () => {
    if (showAddMember) {
      setShowAddMember(false);
    } else {
      setIsEdit(false);
      setIsView(false);
    }
    retrieveReportList();
  };

  const [memberList, setMemberList] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [paramMember, setParamMember] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
  });

  const retrieveMemberList = async (value = paramMember) => {
    const request = {
      ...value,
      // sortBy: selectedOption ? selectedOption.value : "",
      keyword: value.keyword || "",
    };

    setMemberList(prev => ({
      ...prev,
      isLoading: true,
    }));

    try {
      const result = await api.post(
        "Admin/GetMemberListByAdmin",
        request,
        getToken()
      );

      apiUtil.parseResult(
        result,
        (response) => {
          const { code, data } = response.data;
          if (code === 401) {

            message.error(response.data.message);
            redirectToLogin();
            return;
          }

          if (code === 200) {
            setMemberList(prev => ({
              ...prev,
              isLoading: false,
              limit: data.rowLimit,
              data: data.data?.length > 0 ? data.data : [],
              total: data.totalRecords,
              page: data.paging,
            }));
            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }, 0);

            return;
          }
          setMemberList(prev => ({
            ...prev,
            data: [],
            total: 0,
            page: 0,
            limit: 0,
            isLoading: false,
          }));
        },
        (error, type) => {
          console.log(error);

          setMemberList((prev) => ({
            ...prev,
            isLoading: false,
          }));
        }
      );
    } catch (error) {
      console.log(error);

      setMemberList((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  };

  // Add Member Validation Form
  const AddMemberValidation = Yup.object().shape({
    name: Yup.string().required("Please enter the name."),
    marker_name: Yup.string().required("Please enter the marker name."),
  });

  // Edit Member Validation Form
  const EditMemberValidation = Yup.object().shape({
    name: Yup.string().required("Please enter the name."),
    marker_name: Yup.string().required("Please enter the maker name."),
  });

  const submitMemberHandler = async (values, actions) => {

    const isUpdate = isEdit;

    const member = {
      ...(isUpdate && {
        memberId: values.memberId,
      }),
      brandId: isUpdate
        ? values.brandId
        : brandId,
      name: values.name,
      markerName: values.marker_name,
      address: values.address,
      phoneNo: values.phone_number,
    };

    const apiUrl = isUpdate
      ? "Admin/UpdateMemberByAdmin"
      : "Admin/CreateMemberByAdmin";

    try {
      const result = await api.post(
        apiUrl,
        member,
        getToken()
      );

      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 409) {
            message.warning(
              "Marker Name is already in used."
            );

            return;
          }
          if (response.data.code === 200) {
            message.success(
              isUpdate
                ? "Member updated successfully!"
                : "Member saved successfully!"
            );

            actions.resetForm();

            setShowAddMember(false);
            setIsEdit(false);
            retrieveMemberList();

            return;
          }
          if (response.data.code === 401) {

            redirectToLogin();

            return;
          }
          message.warning(response.data.message);

        },
        () => {
          message.error(
            isUpdate
              ? "An error occurred while updating the member."
              : "An error occurred while saving the member."
          );
        }
      );
    } catch (error) {
      console.log(error);
      message.error(
        isUpdate
          ? "An error occurred while updating the member."
          : "An error occurred while saving the member."
      );
    }
    finally {
      actions.setSubmitting(false);
    }
  };

  useEffect(() => {
    retrieveMemberList({
      ...paramMember,
      keyword
    });
    retrieveReportList();
  }, [paramMember.currentPage]);

  //for report
  const refReportTable = createRef();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const [reportList, setReportList] = useState({
    isLoading: true,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [paramReport, setParamReport] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true,
    brandId: brandId,
    startDate: format(startDate, "yyyy-MM-dd"),
    endDate: format(endDate, "yyyy-MM-dd"),
  });
  const mapDataRows = (data, value) => {
    return data && data.length > 0
      ? data.map((row, index) => ({
        ...row,
        tableNum: (value.currentPage - 1) * value.rowLimit + index + 1,
      }))
      : [];
  };

  const retrieveReportList = async (value = paramReport) => {
    value.keyword = keyword || "";
    value.memberId = detailMember.memberId;
    value.startDate = format(startDate, "yyyy-MM-dd");
    value.endDate = format(endDate, "yyyy-MM-dd");

    api
      .post("Admin/GetProductReport", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            const data = response.data.data;
            if (response.data.code === 401) {
              message.warning(response.data.message);
              redirectToLogin();
            } else if (response.data.code === 200) {
              setReportList({
                isLoading: false,
                limit: data.rowLimit,
                data: mapDataRows(data.data, value),
                total: data.totalRecords,
                page: data.paging,
              });
            } else {
              setReportList({
                data: [],
                total: 0,
                page: 0,
                limit: 0,
                isLoading: false,
              });
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };


  useEffect(() => {
    retrieveReportList();
  }, [paramReport, startDate, endDate]);

  const handleDateRangeChange = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setStartDate(startDate);
    setEndDate(endDate);
    setDateRange({ startDate, endDate });
    retrieveReportList();
  };

  const handleInputClick = () => {
    setShowDatePicker((prevState) => !prevState);
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!e.target.closest(".date-input-container")) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  let pageTitle;
  if (showAddMember) {
    pageTitle = "Add Member";
  } else if (isEdit) {
    pageTitle = "Edit Member";
  } else {
    pageTitle = "Member Detail";
  }

  return (
    <>
      {(showAddMember || isEdit || isView) && (
        <>
          <div className="Actions space_between">
            <h6 className="title_text mt-2">{pageTitle}</h6>
            <button className="btn btnClose" onClick={clickBtnCloseForm}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>

          {(showAddMember || isEdit) && (
            <Formik
              enableReinitialize
              initialValues={{
                name: detailMember.name || "",
                marker_name: detailMember.marker_name || "",
                phone_number: detailMember.phone_number || "",
                address: detailMember.address || "",
                memberId: detailMember.memberId || "",
                brandId: detailMember.brandId || "",
              }}
              validationSchema={
                showAddMember
                  ? AddMemberValidation
                  : EditMemberValidation
              }
              validateOnBlur={false}
              onSubmit={submitMemberHandler}
            >
              {({ isSubmitting }) => (
                <Form className="row form-container add-member-point-form">

                  <div className="col-6 mt-2">
                    <CustomInput
                      name="name"
                      type="text"
                      label="Name"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>


                  <div className="col-6 mt-2">
                    <CustomInput
                      name="marker_name"
                      type="text"
                      label="Marker Name"
                      customclass="input_wrapper"
                      hideicon="true"
                      placeholder="Marker Name"
                    />
                  </div>


                  <div className="col-6 mt-2">
                    <CustomInput
                      name="phone_number"
                      type="phone"
                      label="Phone number"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>


                  <div className="col-6 mt-2">
                    <CustomInput
                      name="address"
                      type="text"
                      label="Address"
                      customclass="input_wrapper"
                      hideicon="true"
                    />
                  </div>


                  <div className="col-12 mt-3">
                    <div className="Actions justify-content-end">

                      <button
                        type="button"
                        className="button btnCancel"
                        onClick={clickBtnCloseForm}
                        disabled={isSubmitting}
                      >
                        Cancel
                      </button>


                      <button
                        type="submit"
                        className="button btnAddPM"
                        disabled={isSubmitting}
                      >
                        {
                          isSubmitting
                            ? "Saving..."
                            : showAddMember
                              ? "Create"
                              : "Update"
                        }
                      </button>

                    </div>
                  </div>

                </Form>
              )}
            </Formik>
          )}

          {isView && (
            <>
              <Formik
                initialValues={detailMember}
                validationSchema={EditMemberValidation}
                validateOnBlur={false}
              >
                {({ errors, touched, setFieldValue }) => (
                  <Form className="row form-container add-member-point-form">
                    <div className="col-6 mt-2">
                      <CustomInput
                        name="name"
                        type="text"
                        label="Name"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>
                    <div className="col-6 mt-2">
                      <CustomInput
                        name="marker_name"
                        type="text"
                        label="Marker Name"
                        customclass="input_wrapper"
                        hideicon="true"
                        placeholder="Marker Name"
                        readOnly={true}
                      />
                    </div>
                    <div className="col-6 mt-2">
                      <CustomInput
                        name="phone_number"
                        type="phone"
                        label="Phone number"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>

                    <div className="col-6 mt-2">
                      <CustomInput
                        name="address"
                        type="text"
                        label="Address"
                        customclass="input_wrapper"
                        hideicon="true"
                        readOnly={true}
                      />
                    </div>
                  </Form>
                )}
              </Formik>

              <div className="d-flex justify-content-end gap-16 align-items-center">
                {/* dateRangePicker */}
                <div className="date-input-container ">
                  <input
                    type="text"
                    className="inputBox input-right-side_text "
                    value={`${format(
                      dateRange.startDate,
                      "yyyy MMM dd"
                    )} - ${format(dateRange.endDate, "yyyy MMM dd")}`}
                    readOnly
                    onClick={handleInputClick}
                  />
                  <img
                    src={calenderIcon}
                    className="iconDate"
                    onClick={handleInputClick}
                  />

                  {showDatePicker && (
                    <div className="input-dateRange">
                      <DateRange
                        showDateDisplay={false}
                        ranges={[{ startDate, endDate, key: "selection" }]}
                        onChange={handleDateRangeChange}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="table_container report_table">
                <Table
                  ref={refReportTable}
                  maxBodyHeight={reportList.limit * 80}
                  isLoading={reportList.isLoading}
                  grouping={reportList.grouping}
                  limit={reportList.limit}
                  page={reportList.page}
                  total={reportList.total}
                  data={reportList.data}
                  onPageChange={(page) => {
                    setParamReport({
                      ...paramReport,
                      currentPage: page,
                    });
                  }}
                  columns={[
                    {
                      title: "No",
                      render: (row) => row.tableIndex + 1,
                      width: "80px",
                    },
                    {
                      title: "Date",
                      render: (row) => {
                        if (row.reportDate == null || row.reportDate == "") {
                          return "-";
                        }
                        const date = new Date(row.reportDate);
                        const formattedDate = date.toLocaleDateString("en-US");
                        return formattedDate;
                      },
                      width: "100px",
                    },
                    {
                      title: "Time",
                      render: (row) => {
                        if (row.reportTime == null || row.reportTime == "") {
                          return "-";
                        }
                        const time = new Date(row.reportTime);
                        const formattedTime = time.toLocaleTimeString("en-US", {
                          hour12: true,
                        });
                        return formattedTime;
                      },
                      width: "120px",
                    },
                    {
                      title: "Marker",
                      field: "markerName",
                      width: "100px",
                    },
                    {
                      title: "Quantity",
                      field: "count",
                      width: "100px",
                    },
                    {
                      title: "Weight (kg)",
                      field: "weight",
                      width: "150px",
                    },
                    {
                      title: "Rate",
                      field: "rate",
                      width: "150px",
                    },
                    {
                      title: "Price",
                      field: "price",
                      width: "150px",
                    },
                    {
                      title: "Carry Name",
                      field: "carryName",
                      width: "200px",
                    },
                  ]}
                />
              </div>
            </>
          )}
        </>
      )}

      <div className="Actions space_between">
        <h6 className="title_text mt-2">Member</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}

          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={(value) => retrieveMemberList({
              ...paramMember,
              keyword: value,
              currentPage: 1,
            })}
          />
          {!showAddMember && (
            <CustomButton
              icon={add}
              text="Add Member"
              addIcon={true}
              className="btnAdd"
              onClick={clickAddMember}
            />
          )}
        </div>
      </div>

      <div className="table_container member_table">
        <Table
          ref={refMemberTable}
          maxBodyHeight={memberList.limit * 100}
          isLoading={memberList.isLoading}
          grouping={memberList.grouping}
          limit={memberList.limit}
          page={memberList.page}
          total={memberList.total}
          data={memberList.data}
          onPageChange={(page) => {
            setParamMember({
              ...paramMember,
              currentPage: page,
            });
            retrieveMemberList(paramMember);
          }}
          columns={[
            {
              title: "No",
              render: (row) => row.tableIndex + 1,
              width: "80px",
            },
            {
              title: "Name",
              field: "name",
            },
            {
              title: "Marker",
              field: "markerName"
            },
            {
              title: "Address",
              field: "address"
            },
            {
              title: "Email",
              field: "email",
            },
            {
              title: "Phone Number",
              field: "phoneNo",
            },
            {
              title: "Edit",
              sorting: false,
              render: (row) => {
                return (
                  <Box
                    className="editIcon"
                    onClick={() => clickEditMember(row)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              width: "80px",
            },
            {
              title: "View",
              sorting: false,
              render: (row) => {
                return (
                  <Box
                    className="viewIcon"
                    onClick={() => clickViewMember(row)}
                  >
                    <img src={view} alt="" className="imgIcon" />
                  </Box>
                );
              },
              width: "80px",
            },
          ]}
        />
      </div>
    </>
  );
};

export default Member;
